export default function TrialReminder() {
  // Placeholder - trial reminder not needed in Enterprise Suite
  return null;
}
